import TrashIcon from "@redotech/redo-icons/trash-01.svg";
import { SegmentConditionType } from "@redotech/redo-model/marketing/segments/segment-types";
import { memo } from "react";
import { RedoButton } from "../../arbiter-components/buttons/redo-button";
import { RedoListItem } from "../../arbiter-components/list/redo-list";
import { RedoSingleSelectDropdownInput } from "../../arbiter-components/select-dropdown/redo-single-select-dropdown-input";
import { Flex } from "../../flex";

const conditionTypeToFriendly: Partial<Record<SegmentConditionType, string>> = {
  [SegmentConditionType.CUSTOMER_ACTIVITY]: "A person’s activity",
  [SegmentConditionType.CUSTOMER_ATTRIBUTE]: "A person’s characteristics",
  // SegmentConditionType.CUSTOM_EVENT excluded until MKTG-1873
};

const options: RedoListItem<SegmentConditionType>[] = (
  Object.values(SegmentConditionType) as SegmentConditionType[]
)
  .filter((type) => type in conditionTypeToFriendly)
  .map((type) => ({
    id: type,
    type: "text",
    text: conditionTypeToFriendly[type]!,
    value: type,
  }));

export const SegmentConditionTypeSelect = memo(
  function SegmentConditionTypeSelect({
    conditionTypeSelected,
    deleteRequested,
  }: {
    conditionTypeSelected: (mode: SegmentConditionType) => void;
    deleteRequested: () => void;
  }) {
    return (
      <Flex justify="space-between">
        <Flex>
          <RedoSingleSelectDropdownInput
            fitToAnchor={false}
            options={options}
            optionSelected={({ item }) => conditionTypeSelected(item.value)}
            placeholder="Choose a condition"
            size="xs"
          />
        </Flex>
        <RedoButton
          IconLeading={TrashIcon}
          onClick={deleteRequested}
          theme="destructive"
        />
      </Flex>
    );
  },
);
